"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCancelledError = exports.checkCancellation = exports.default = void 0;
var CANCELLED_ACTION_MARKER = Symbol('CANCELLED_ACTION_MARKER');
var CANCELLED_ERROR_MESSAGE = 'CANCELLED_ERROR_MESSAGE';
var _default = CANCELLED_ACTION_MARKER;
exports.default = _default;

var checkCancellation = function checkCancellation(parcelData) {
  if (parcelData.value === CANCELLED_ACTION_MARKER) {
    throw new Error(CANCELLED_ERROR_MESSAGE);
  }

  return parcelData;
};

exports.checkCancellation = checkCancellation;

var isCancelledError = function isCancelledError(e) {
  return e.message === CANCELLED_ERROR_MESSAGE;
};

exports.isCancelledError = isCancelledError;